<template>
  <div class="login">
    <div class="masking" v-if="code" @click="closeMasking"></div>
	  <!-- 登录 -->
    <div class="top">
      <!-- <div class="logo"></div> -->
      <div class="title">
        <a><p class="big">中小学法治教育培育工程网络培训平台</p></a>
        <!-- <p class="small">2020国培计划</p> -->
      </div>
       <div class="contact" @mouseover="showCode" @mouseleave="closeMasking">
        <span class="text" style="margin-left: 200px">联系客服</span>
        <img src="../assets/images/wechat.png" alt="联系我们">
        <div class="code" v-if="code">
          <img class="code_bg" src="../assets/images/code_bg.png" alt="">
          <img class="qrcode" src="../assets/images/weixin.jpg" alt="">
        </div>
      </div>

    </div>
    <div class="login_content">
      <div class="login_logo">
        <img src="../assets/images/login_bg.png" alt="">
      </div>
      <div class="login_box">
        <div class="list">
          <img style="width: 0.23rem;height: 0.25rem;margin: 0.1rem 0 0 0.18rem;" src="../assets/images/login_account.png" alt="">
          <span></span>
          <input type="text" placeholder="请输手机号" v-model="account">
        </div>
        <div class="list">
          <img style="width: 0.19rem;height: 0.25rem;margin: 0.09rem 0 0 0.2rem;" src="../assets/images/login_password.png" alt="">
          <span></span>
          <input type="password" placeholder="默认密码是手机号后六位" v-model="password">
        </div>
        <div class="drag" ref="dragDiv">
          <div class="drag_bg"></div>
          <div class="drag_text">{{confirmWords}}</div>
          <div ref="moveDiv" @mousedown="mousedownFn($event)" :class="{'handler_ok_bg':confirmSuccess}+' handler handler_bg'" style="position: absolute;top: 0px;left: 0px;"></div>
         </div>
        <div class="method">
          <!-- <div class="checked">
            <input type="checkbox" id="checkbox" v-model="checked">
            <label for="checkbox" class="days">10天内免登陆</label>
          </div> -->
          <div class="toPassword" @click="toPassword">忘记密码？</div>
        </div>
        <div class="btnContainer" @click="login">
          <div>点击登录</div>
        </div>
        <p v-if="wrong" class="wrong">账号或密码错误</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {

  data () {
    return {
      wrong:false,
      account:'',
      password:'',
      no_login:true,
      checked:false,
      code:false,

      beginClientX:0,   /*距离屏幕左端距离*/
      mouseMoveStata:false,  /*触发拖动状态 判断*/
      maxwidth:'',    /*拖动最大宽度，依据滑块宽度算出来的*/
      confirmWords:'拖动滑块验证', /*滑块文字*/
      confirmSuccess:false   /*验证成功判断*/
    }
  },
  mounted:function(){
    this.maxwidth = this.$refs.dragDiv.clientWidth - this.$refs.moveDiv.clientWidth;
    document.getElementsByTagName('html')[0].addEventListener('mousemove',this.mouseMoveFn);
    document.getElementsByTagName('html')[0].addEventListener('mouseup',this.moseUpFn)
  },
	methods:{
    closeMasking(){
      this.code = false;
    },
    showCode(){
      this.code = true;
    },
    toPassword(){
      this.$router.push("/Mobile");
    },
    login(){
      var _this = this;


      if(!this.mouseMoveStata){
        _this.$mResToast({
          type:'error',
          msg:'请先完成验证',
          duration:3000,
          isIcon:true,
        });
        return;
      }

      // this.$router.push('/Index');
      if(!this.account || (!this.password)){
        this.wrong = true;
      }else{
        this.wrong = false;
      }
      var params = {
        loginInfo:this.account,
        password:this.password,
        captcha:'',
        uuid:'',
        source:_this.checked ? 1 : 0,
      }
      this.post('/trainee/login',params,(data)=>{

        if(data.status == 200){
          localStorage.setItem('token',data.data.access_token);
          localStorage.setItem('event',JSON.stringify(data.data.event));
          localStorage.setItem('config',JSON.stringify(data.data.config));
          if(data.data.event.status == 1){
            this.$router.push('./Course');
          }else if(data.data.event.status == 2){
            this.$router.push('./Course');
          }else{
            this.$router.push('/Course');
          }
        }else{
          _this.$mResToast({
            type:data.status == 200 ? 'success' : 'error',
            msg:data.msg,
            duration:3000,
            isIcon:true,
          });
        }
        console.log(data);
      })
    },


    mousedownFn:function (e) {
      if(!this.confirmSuccess){
       e.preventDefault && e.preventDefault(); //阻止文字选中等 浏览器默认事件
       this.mouseMoveStata = true;
       this.beginClientX = e.clientX;
      }
    },  //mousedoen 事件
     successFunction(){
      this.confirmSuccess = true
      this.confirmWords = '验证通过';
      if(window.addEventListener){
       document.getElementsByTagName('html')[0].removeEventListener('mousemove',this.mouseMoveFn);
       document.getElementsByTagName('html')[0].removeEventListener('mouseup',this.moseUpFn);
      }else {
       document.getElementsByTagName('html')[0].removeEventListener('mouseup',()=>{});
      }
      document.getElementsByClassName('drag_text')[0].style.color = '#fff'
      document.getElementsByClassName('handler')[0].style.left = this.maxwidth + 'px';
      document.getElementsByClassName('drag_bg')[0].style.width = this.maxwidth + 'px';
     },    //验证成功函数
     mouseMoveFn(e){
      if(this.mouseMoveStata){
       let width = e.clientX - this.beginClientX;
       if(width>0 && width<=this.maxwidth){
        document.getElementsByClassName('handler')[0].style.left = width + 'px';
        document.getElementsByClassName('drag_bg')[0].style.width = width + 'px';
       }else if(width>this.maxwidth){
        this.successFunction();
       }
      }
     },     //mousemove事件
     moseUpFn(e){
      this.mouseMoveStata = false;
      var width = e.clientX - this.beginClientX;
      if(width<this.maxwidth){
       document.getElementsByClassName('handler')[0].style.left = 0 + 'px';
       document.getElementsByClassName('drag_bg')[0].style.width = 0 + 'px';
      }
     },      //mouseup事件



	}
}
</script>

<style scoped>
.login{
  width: 100%;
}

.masking{
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0,0,0,0.7);
  z-index: 20;
}




.drag{
  position: relative;
  background-color: #e8e8e8;
  width: 400px;
  height: 0.37rem;
  line-height: 0.37rem;
  text-align: center;
  margin-top: 0.24rem;
  margin: 0 auto 0.2rem auto;
 }
 .handler{
  width: 40px;
  height: 32px;
  border: 1px solid #ccc;
  cursor: move;
 }
 .handler_bg{
  background: #fff url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA3hpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDIxIDc5LjE1NTc3MiwgMjAxNC8wMS8xMy0xOTo0NDowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDo0ZDhlNWY5My05NmI0LTRlNWQtOGFjYi03ZTY4OGYyMTU2ZTYiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NTEyNTVEMURGMkVFMTFFNEI5NDBCMjQ2M0ExMDQ1OUYiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NTEyNTVEMUNGMkVFMTFFNEI5NDBCMjQ2M0ExMDQ1OUYiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTQgKE1hY2ludG9zaCkiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo2MTc5NzNmZS02OTQxLTQyOTYtYTIwNi02NDI2YTNkOWU5YmUiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6NGQ4ZTVmOTMtOTZiNC00ZTVkLThhY2ItN2U2ODhmMjE1NmU2Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+YiRG4AAAALFJREFUeNpi/P//PwMlgImBQkA9A+bOnfsIiBOxKcInh+yCaCDuByoswaIOpxwjciACFegBqZ1AvBSIS5OTk/8TkmNEjwWgQiUgtQuIjwAxUF3yX3xyGIEIFLwHpKyAWB+I1xGSwxULIGf9A7mQkBwTlhBXAFLHgPgqEAcTkmNCU6AL9d8WII4HOvk3ITkWJAXWUMlOoGQHmsE45ViQ2KuBuASoYC4Wf+OUYxz6mQkgwAAN9mIrUReCXgAAAABJRU5ErkJggg==") no-repeat center;
 }
 .handler_ok_bg{
  background: #fff url("../assets/images/mobile_check.png") no-repeat center;
 }
 .drag_bg{
  background-color: #7ac23c;
  height: 0.37rem;
  width: 0px;
 }
 .drag_text{
  font-size: 0.21rem;
  color: #fff;
  position: absolute;
  top: 0px;
  width: 100%;
  text-align: center;
  -moz-user-select: none;
  -webkit-user-select: none;
  user-select: none;
  -o-user-select:none;
  -ms-user-select:none;
 }





.top{
  width: 15rem;
  height: 1.54rem;
  margin: 0 auto;
}
.logo{
  width: 0.79rem;
  height: 0.61rem;
  float: left;
  background-color: blue;
  margin: 0.25rem 0.24rem 0.3rem 0;
}
.title{
 float: left;
 width: 10rem;
}
.big{
  float: left;
  width: 10rem;
  font-size: 0.5rem;
  color: #0073d3;
  height: 0.5rem;
  line-height: 0.5rem;
  margin-top:0.4rem;
}
.small{
  float: left;
  width: 10rem;
  font-size: 0.25rem;
  color: #989898;
  height: 0.25rem;
  line-height: 0.25rem;
  margin-top: 0.28rem;
}
.contact{
  float: right;
  width: 4.9rem;
  height: 0.56rem;
  margin: 0.54rem 0.07rem 0 0;
  cursor: pointer;
  position: relative;
  z-index: 999;
  cursor: pointer;
}
.contact span{
  font-size: 0.25rem;
  color: #989898;
  line-height: 0.56rem;
  float: left;
}
.contact img{
  width: 0.56rem;
  height: 0.56rem;
  margin-left: 0.3rem;
  float: left;
}
.code{
  width: 2.11rem;
  height: 2.13rem;
  position: absolute;
  top: 0.6rem;
  right: 0.8rem;
  z-index: 30;
}
.code .code_bg{
  float: left;
  width: 2.11rem;
  height: 2.13rem;
  margin: 0;
}
.code .qrcode{
  width: 1.77rem;
  height: 1.69rem;
  position: absolute;
  left: 50%;
  top: 0.31rem;
  transform: translate(-50%,0);
  margin: 0;
}

.login_logo{
  width: 100%;
  height: 6.87rem;
  /* width: 15rem; */
  /* height: 7.45rem; */
  position: relative;
}
.login_logo img{
  width: 100%;
  height: 100%;
  position: absolute;
}
.login_content{
  width: 100%;
  /* width: 15rem; */
  /* height: 7.45rem; */
  margin: 0 auto;
  position: relative;
}
.login_box{
  width: 5.67rem;
  height: 4.46rem;
  background-color: #fff;
  border-radius: 0.15rem;
  position: absolute;
  /* right: 0.3rem; */
  right: 2.37rem;
  top: 1rem;
  padding-top: 1rem;
}
.login_box .list{
  width: 4.24rem;
  height: 0.45rem;
  border-radius: 0.1rem;
  border: 0.01rem solid #8b8b8b;
  margin: 0 auto 0.25rem auto;
  position: relative;
}
.login_box .list img{
  float: left;
}
.login_box .list span{
  width: 0.01rem;
  height: 0.32rem;
  background-color: #b8b8b8;
  position: absolute;
  top: 50%;
  left: 0.54rem;
  transform: translate(0,-50%);
}
.login_box .list input{
  width: 3rem;
  height: 0.4rem;
  float: left;
  border: none;
  outline: none;
  margin-top: 0.02rem;
  margin-left: 0.56rem;
}
.login_box .list p{
  font-size: 0.21rem;
  color: #ff4200;
}
.login_box .method{
  width: 4.24rem;
  height: 0.2rem;
  line-height: 0.2rem;
  margin: 0 auto;
}
.login_box .method .checked{
  float: left;
  cursor:pointer;
}
.login_box .method .checked input{
  float: left;
  margin-right: 0.1rem;
  margin-top: 0.04rem;
}
.login_box .method .checked .days{
  float: right;
  font-size: 0.17rem;
  color: #8b8b8b;
}
.login_box .method .toPassword{
  float: right;
  font-size: 0.17rem;
  color: #8b8b8b;
  cursor:pointer;
}
.btnContainer{
  width: 4.25rem;
  height: 0.48rem;
  background-color: #2b73cc;
  font-size: 0.25rem;
  color: #fff;
  text-align: center;
  line-height: 0.48rem;
  margin: 0.1rem auto 0.09rem auto;
  cursor:pointer;
}
.wrong{
  font-size: 0.21rem;
  color: #ff4200;
  float: right;
  margin-right: 0.62rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue